export default "__VITE_ASSET__DWQvFdfF__"